export const LEFT = 'left';
export const CENTER = 'center';
export const RIGHT = 'right';

export const ALIGNMENT_OPTIONS = [LEFT, CENTER, RIGHT];
